import { Version } from '@expepharma/version/version';

export const EXPEPHARMA_VERSION = new Version('1.0.1').full;
